import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import useLayout from "../../../hooks/Layout/useLayout";
export default function Nav({active =1,onClick}) {
  const navigate = useNavigate()
  const { navigateTo } = useLayout();
  return (
    <Wrapper>
      <div className="left" onClick={() => {
        navigateTo("/");
      }}>
        <img src="image/icons/home.png" alt="" />
      </div>
      <div className="center">
        <div className="tabs"> 
          <div className={"tab-item" + (active === 2 ? ' active' : '')} onClick={() => {onClick(2)}}><FormattedMessage id="游戏账户" /></div>
          <div className={"tab-item" + (active === 1 ? ' active' : '')} onClick={() => {onClick(1)}}><FormattedMessage id="链上账户" /></div>
        </div>
      </div>
      <div className="left" onClick={() => {
        navigateTo("/user");
      }}>
        <img src="image/icons/settings.webp" alt="" />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding: 1.0rem 2.0rem;
  align-items: center;
  .center {
    flex: 1;
    text-align: center;
  }
  .left,
  .right {
    padding-top: 2px;
  }
  .left img,
  .right img {
    width: 2.5rem;
    height: 2.5rem;
  }
  .tabs {
    background: #e9e9e9;
    border-radius: 3.2rem;
    display: inline-block;
    padding: 3px;
    .tab-item {
      display: inline-block;
      padding: .5rem 1.5rem;
    }
    .tab-item.active {
      background-color: #fff;
      background: #ffffff;
      border-radius: 3.2rem;
    }
  }
`;
